/* eslint-disable import/no-duplicates */
import { format, isValid } from "date-fns";

import { dateTimeFormat } from "constants/datetime";

/**
 * Format datetime
 * @param {*} value Input value is 2023-09-18 16:40:16 +0900
 * @returns  2023-09-18
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatDate = (date: any, formatType = dateTimeFormat.DATE_JP) => {
  if (!date) return "";

  let tempDate = date;

  // Handle timestamp (numeric string)
  if (typeof date === "string" && /^\d+$/.test(date)) {
    tempDate = parseInt(date);
  }

  const dateFormat = new Date(tempDate);
  if (!isValid(dateFormat)) {
    return tempDate;
  }

  return format(new Date(tempDate) || new Date(), formatType);
};
